import { IAppointmentSummary } from "@signal/asp-data-commons";
import { IAvailability, IScheduleAvailability } from "@signal/asp-data-commons/lib/interfaces/availability";
import { DateTime } from 'luxon';
import produce from 'immer';
import * as fromActions from './schedule-dashboard.action';


export interface IDashboardDetails {
  startDate: string,
  endDate: string,
  viewMode: string,
  viewType: string,
  filterValue: any,
  selectedDate : DateTime,
}

export interface ScheduleDashboardState {
  // additional entities state properties
  slotAvailability: IAvailability,
  appointmentSummary: IAppointmentSummary[],
  dashboardDetails: IDashboardDetails,
  department: string,
  availabilityLoaded: boolean,
  appointmentLoaded: boolean;
  error: string
}

export const initialState: ScheduleDashboardState = {
  // additional entity state properties
  slotAvailability: {} as IAvailability,
  appointmentSummary: [{ appointments: [] }] as IAppointmentSummary[],
  dashboardDetails: {} as IDashboardDetails,
  department: '',
  availabilityLoaded: false,
  appointmentLoaded: false,
  error: ''
};

export function scheduleDashboardReducer(
  state: ScheduleDashboardState = initialState,
  action: fromActions.ScheduleDashboardActions): ScheduleDashboardState {

  switch (action.type) {
    case fromActions.ScheduleDashboardActionTypes.LOAD_SCHEDULE_DASHBOARD_SLOT: {
      return produce(state, draftState => {
        const department = action instanceof fromActions.LoadScheduleDashboardSlot ? action.payload.department?.toLowerCase() : '';
        draftState.availabilityLoaded = false;
        draftState.department = department;
        draftState.error = '';
      });
    }

    case fromActions.ScheduleDashboardActionTypes.LOAD_SCHEDULE_DASHBOARD_SLOT_SUCCESS: {
      return produce(state, draftState => {

        const department = action instanceof fromActions.LoadScheduleDashboardSlotSuccess ? action.payload.department?.toLowerCase() : '';
        const payload = action instanceof fromActions.LoadScheduleDashboardSlotSuccess ? action.payload?.availabilityData : undefined;
        draftState.slotAvailability = payload;
        draftState.department = department;
        draftState.availabilityLoaded = true;
        draftState.error = '';
      })
    }

    case fromActions.ScheduleDashboardActionTypes.LOAD_SCHEDULE_DASHBOARD_SLOT_FAILURE: {
      return produce(state, draftState => {

        const payload = action instanceof fromActions.LoadScheduleDashboardSlotFailure ? action.payload : undefined;
        const department = payload?.department?.toLowerCase();
        draftState.availabilityLoaded = false;
        draftState.department = department;
        draftState.appointmentLoaded = state.appointmentLoaded;
        draftState.error = payload.error;
      });
    }

    case fromActions.ScheduleDashboardActionTypes.LOAD_SCHEDULE_DASHBOARD_APPOINTMENTS: {
      return produce(state, draftState => {
        const department = action instanceof fromActions.LoadScheduleDashboardAppointments ? action.payload.department?.toLowerCase() : '';
        draftState.appointmentLoaded = false;
        draftState.availabilityLoaded = state.availabilityLoaded;
        draftState.department = department;
        draftState.error = '';
      });
    }

    case fromActions.ScheduleDashboardActionTypes.LOAD_SCHEDULE_DASHBOARD_APPOINTMENTS_REFRESH: {
      return produce(state, draftState => {
        const department = action instanceof fromActions.LoadScheduleDashboardAppointmentsRefresh ? action.payload.department?.toLowerCase() : '';
        draftState.appointmentLoaded = state.appointmentLoaded;
        draftState.availabilityLoaded = state.availabilityLoaded;
        draftState.department = department;
        draftState.error = '';
      });
    }

    case fromActions.ScheduleDashboardActionTypes.LOAD_SCHEDULE_DASHBOARD_APPOINTMENTS_SUCCESS: {
      return produce(state, draftState => {

        const department = action instanceof fromActions.LoadScheduleDashboardAppointmentsSuccess ? action.payload.department?.toLowerCase() : '';
        const payload = action instanceof fromActions.LoadScheduleDashboardAppointmentsSuccess ? action.payload?.appointmentSummary : undefined;
        draftState.appointmentSummary = payload;
        draftState.slotAvailability = state.slotAvailability;
        draftState.availabilityLoaded = state.availabilityLoaded;
        draftState.department = department;
        draftState.appointmentLoaded = true;
        draftState.error = '';
      })
    }

    case fromActions.ScheduleDashboardActionTypes.LOAD_SCHEDULE_DASHBOARD_APPOINTMENTS_FAILURE: {
      return produce(state, draftState => {
        const payload = action instanceof fromActions.LoadScheduleDashboardAppointmentsFailure ? action.payload : undefined;
        const department = payload?.department?.toLowerCase();
        draftState.appointmentLoaded = false;
        draftState.department = department;
        draftState.availabilityLoaded = state.availabilityLoaded;
        draftState.error = payload.error;
      });
    }

    case fromActions.ScheduleDashboardActionTypes.UPDATE_SCHEDULE_DASHBOARD_DETAILS: {
      return produce(state, draftState => {
        const department = action instanceof fromActions.UpdateScheduleDashboardDetail ? action.payload.department?.toLowerCase() : '';
        const dashboardDetails = action instanceof fromActions.UpdateScheduleDashboardDetail ? action.payload.dashboardDetails : {} as IDashboardDetails;
        draftState.dashboardDetails =  dashboardDetails;
        draftState.availabilityLoaded = state.availabilityLoaded;
        draftState.appointmentLoaded = state.appointmentLoaded;
        draftState.department = department;
        draftState.error = '';
      });
    }

    case fromActions.ScheduleDashboardActionTypes.CLEAR_SCHEDULE_DASHBOARD_SLOT: {
      return produce(state, draftState => {
        const department = action instanceof fromActions.ClearScheduleDashboardSlot ? action.payload.department?.toLowerCase() : '';
        draftState.slotAvailability = {} as IAvailability;
        draftState.department = department;
        draftState.availabilityLoaded = false;
        draftState.error = '';
      });
    }

    default:
      return state;

  }
}